// Ticket attachments (manual action-plan tickets, auto-tickets, raise-ticket dialog) can be any file type
// since 2026-10-28. Photos still show as thumbnails; other files show as a file tile that opens the file.

// Types the browser can show in an <img> (one list for extensions and MIME subtypes; image/heic, image/tiff... are
// files - most browsers cannot draw them).
const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'jfif', 'pjpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'avif']
const IMAGE_MIME_SUBTYPES = ['jpg', 'jpeg', 'pjpeg', 'png', 'gif', 'webp', 'bmp', 'svg+xml', 'avif']

// Server upload keys look like EA_1_{yyyyMMddHHmmss}_{12 hex}_{client name}; older ones EA_1_{yyyyMMddHHmmss}{name}.
const UPLOAD_PREFIX = /^EA_1_\d{14}(_[0-9a-f]{12}_)?/i

const lastSegment = value => {
    const text = String(value || '').split(/[?#]/)[0]
    const parts = text.split(/[/\\]/)
    let name = parts[parts.length - 1] || ''
    try {
        name = decodeURIComponent(name)
    } catch {
        // keep the raw segment when it is not valid URI encoding
    }
    return name
}

export const attachmentExtension = value => {
    const name = lastSegment(value)
    const dot = name.lastIndexOf('.')
    if (dot <= 0 || dot === name.length - 1) return ''
    return name.slice(dot + 1).toLowerCase()
}

/**
 * True when the attachment can be shown as a picture.
 * FileType (a MIME type, or an extension on some older rows) wins; otherwise the extension of the file name /
 * key / URL. No type and no extension = picture (every ticket attachment before 2026-10-28 was a photo).
 */
export const isImageAttachment = file => {
    if (!file) return false
    const type = String(file.FileType || file.type || '').trim().toLowerCase()
    if (type) {
        if (type.includes('/')) {
            const [major, minor] = type.split(';')[0].trim().split('/')
            return major === 'image' && IMAGE_MIME_SUBTYPES.includes(minor)
        }
        return IMAGE_EXTENSIONS.includes(type.replace(/^\./, ''))
    }
    const ext =
        attachmentExtension(file.name) ||
        attachmentExtension(file.FileName) ||
        attachmentExtension(file.FileKey) ||
        attachmentExtension(file.FileURL || file.SignedURL || file.ImagePathUrl || file.url)
    if (!ext) return true
    return IMAGE_EXTENSIONS.includes(ext)
}

/** Short display name, e.g. "report.pdf" for qms_images/2026/10/EA_1_20261028101500_ab12cd34ef56_report.pdf. */
export const attachmentLabel = file => {
    const source =
        (file && (file.name || file.FileName || file.FileKey || file.FileURL || file.SignedURL || file.url)) || ''
    const name = lastSegment(typeof file === 'string' ? file : source).replace(UPLOAD_PREFIX, '')
    return name || 'File'
}
